import Tab from '../tab/Tab';
import { TabModel } from '../tabs/useTabs';
import { useMatch, useNavigate } from 'react-router-dom';

interface NavTabProps {
  title: string;
  to: string;
  isDotted?: boolean;
}

export interface NavTabModel extends TabModel {
  to: string;
}

export const NavTab = ({ title, to, isDotted }: NavTabProps) => {
  const navigate = useNavigate();
  const match = useMatch(`${to}/*`);

  return (
    <Tab
      key={title}
      title={title}
      active={!!match}
      onClicked={() => navigate(to)}
      isDotted={isDotted}
    />
  );
};

export default NavTab;
